/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * The status of the ticket
 */
export enum FetchTicketResponseStatus {
  new= 'new',
  closed= 'closed',

}
